import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { UserGroupCombineMethod } from "./user-group-combine-method";

export interface IUserGroupConfiguration {
    combineMethod: UserGroupCombineMethod;

    readonly userGroupIds: Array<number>;

    readonly children: Array<IUserGroupConfiguration>;
}

@JsonObject()
export class UserGroupConfiguration implements IUserGroupConfiguration {
    @JsonProperty("combine_method")
    combineMethod: UserGroupCombineMethod;

    @JsonProperty("user_group_ids")
    @JsonElementType(Number)
    userGroupIds: Array<number>;

    @JsonProperty("children")
    @JsonElementType(UserGroupConfiguration)
    children: Array<IUserGroupConfiguration>;
}
